function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "translate(1 1)",
  stroke: "#80858e",
  strokeWidth: 2,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("circle", {
  cx: 5.333,
  cy: 5.333,
  r: 5.333
}), React.createElement("path", {
  d: "M11.567 12.233l-2.9-2.9"
}));

function SvgIconSearch(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 14 15"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTQgMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgc3R5bGU9InN0cm9rZTojODA4NThlO3N0cm9rZS13aWR0aDoyO2ZpbGw6bm9uZTtmaWxsLXJ1bGU6ZXZlbm9kZDtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEgMSkiPjxjaXJjbGUgY3g9IjUuMzMzMzMzIiBjeT0iNS4zMzMzMzMiIHI9IjUuMzMzMzMzIi8+PHBhdGggZD0ibTExLjU2NjY2NjcgMTIuMjMzMzMzMy0yLjkwMDAwMDAzLTIuODk5OTk5OTciLz48L2c+PC9zdmc+";
export { SvgIconSearch as ReactComponent };